import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getRoles(page, q = '', limit = 10) {
    const params = {
      cursor: page,
      limit,
      q,
    };
    const url = '/roles';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getRole(id) {
    return api.get(`/roles/${id}`);
  },
  deleteRole(id) {
    return api.delete(`/roles/${id}`);
  },
  restoreRole(id) {
    return api.put(`/roles/${id}/reactivate`);
  },
  updateRole(id, payload) {
    return api.put(`/roles/${id}`, { role: payload });
  },
  createRole(payload) {
    return api.post(`/roles`, { role: payload });
  },
  getPages() {
    return api.get(`/pages`);
  },
};
